import React, { useState } from 'react';
import { NetworkIcon, MapIcon, CreditCardIcon, DatabaseIcon, FileTextIcon, MessageSquareIcon, MailIcon, BuildingIcon, ZapIcon, KeyIcon, GlobeIcon, CheckCircleIcon, XCircleIcon, RefreshCwIcon, AlertCircleIcon, WrenchIcon, LinkIcon, ShieldIcon, EyeIcon, PlusIcon } from 'lucide-react';
export const IntegrationSettings = () => {
  const [showApiKey, setShowApiKey] = useState(false);
  const [testingConnection, setTestingConnection] = useState(false);
  const handleTestConnection = () => {
    setTestingConnection(true);
    setTimeout(() => setTestingConnection(false), 2000);
  };
  return <div className="space-y-8" data-id="element-1148">
      {/* Core System Integrations */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1149">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1150">
          Core System Integrations
        </h3>
        <div className="space-y-6" data-id="element-1151">
          {/* GIS Integration */}
          <div data-id="element-1152">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1153">
              GIS Integration Settings
            </label>
            <div className="space-y-4" data-id="element-1154">
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1155">
                <div className="flex items-center justify-between mb-4" data-id="element-1156">
                  <div className="flex items-center" data-id="element-1157">
                    <MapIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-1158" />
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1159">
                      GIS Server Configuration
                    </h4>
                  </div>
                  <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-1160">
                    Connected
                  </span>
                </div>
                <div className="space-y-3" data-id="element-1161">
                  <div className="grid grid-cols-2 gap-4" data-id="element-1162">
                    <div data-id="element-1163">
                      <label className="block text-xs text-gray-500 mb-1" data-id="element-1164">
                        Server URL
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="https://gis.example.com" data-id="element-1165" />
                    </div>
                    <div data-id="element-1166">
                      <label className="block text-xs text-gray-500 mb-1" data-id="element-1167">
                        API Version
                      </label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-1168">
                        <option data-id="element-1169">v2.0</option>
                        <option data-id="element-1170">v1.0</option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-1171">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1172">
                      Authentication Token
                    </label>
                    <div className="flex space-x-2" data-id="element-1173">
                      <input type={showApiKey ? 'text' : 'password'} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm" value="gis_token_123456789" data-id="element-1174" />
                      <button onClick={() => setShowApiKey(!showApiKey)} className="px-3 py-2 border border-gray-300 rounded-md" data-id="element-1175">
                        <EyeIcon className="h-4 w-4 text-gray-500" data-id="element-1176" />
                      </button>
                    </div>
                  </div>
                  <div data-id="element-1177">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1178">
                      Layer Mapping
                    </label>
                    <div className="space-y-2" data-id="element-1179">
                      {[{
                      name: 'Parcels',
                      layer: 'land_parcels'
                    }, {
                      name: 'Buildings',
                      layer: 'structures'
                    }, {
                      name: 'Zones',
                      layer: 'zoning_areas'
                    }].map(mapping => <div key={mapping.name} className="flex items-center justify-between text-sm" data-id="element-1180">
                          <span className="text-gray-600" data-id="element-1181">{mapping.name}</span>
                          <input type="text" className="px-2 py-1 border border-gray-300 rounded-md" value={mapping.layer} data-id="element-1182" />
                        </div>)}
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-1183">
                    <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1184">
                      Test Connection
                    </button>
                    <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-1185">
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Payment Gateway */}
          <div data-id="element-1186">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1187">
              Payment Gateway Configuration
            </label>
            <div className="space-y-4" data-id="element-1188">
              {[{
              name: 'TeleBirr Integration',
              status: 'active',
              type: 'Mobile Money'
            }, {
              name: 'CBE Birr Gateway',
              status: 'active',
              type: 'Bank Integration'
            }, {
              name: 'Cash Payment System',
              status: 'active',
              type: 'POS Integration'
            }].map(gateway => <div key={gateway.name} className="border border-gray-200 rounded-lg p-4" data-id="element-1189">
                  <div className="flex items-center justify-between mb-4" data-id="element-1190">
                    <div data-id="element-1191">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-1192">
                        {gateway.name}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-1193">{gateway.type}</p>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${gateway.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-1194">
                      {gateway.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  <div className="space-y-3" data-id="element-1195">
                    <div data-id="element-1196">
                      <label className="block text-xs text-gray-500 mb-1" data-id="element-1197">
                        API Endpoint
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="https://api.gateway.com" data-id="element-1198" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-1199">
                      <div data-id="element-1200">
                        <label className="block text-xs text-gray-500 mb-1" data-id="element-1201">
                          Merchant ID
                        </label>
                        <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="MERCH_123" data-id="element-1202" />
                      </div>
                      <div data-id="element-1203">
                        <label className="block text-xs text-gray-500 mb-1" data-id="element-1204">
                          API Key
                        </label>
                        <input type="password" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" value="••••••••••••" data-id="element-1205" />
                      </div>
                    </div>
                    <div className="flex justify-end space-x-2" data-id="element-1206">
                      <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1207">
                        Test Gateway
                      </button>
                      <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-1208">
                        Update Settings
                      </button>
                    </div>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1209">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-1210" />
                Add Payment Gateway
              </button>
            </div>
          </div>
          {/* Accounting System */}
          <div data-id="element-1211">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1212">
              Accounting System Integration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1213">
              <div className="mb-4" data-id="element-1214">
                <div className="flex items-center justify-between" data-id="element-1215">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1216">
                    GL Account Mapping
                  </h4>
                  <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full" data-id="element-1217">
                    Syncing Daily
                  </span>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1218">
                <div className="space-y-2" data-id="element-1219">
                  {[{
                  type: 'Property Tax Revenue',
                  account: '4001-001'
                }, {
                  type: 'Service Fees',
                  account: '4002-001'
                }, {
                  type: 'Penalties & Interest',
                  account: '4003-001'
                }, {
                  type: 'Receivables',
                  account: '1200-001'
                }].map(mapping => <div key={mapping.type} className="flex items-center justify-between text-sm" data-id="element-1220">
                      <span className="text-gray-600" data-id="element-1221">{mapping.type}</span>
                      <input type="text" className="px-2 py-1 border border-gray-300 rounded-md" value={mapping.account} data-id="element-1222" />
                    </div>)}
                </div>
                <div className="pt-4 border-t border-gray-200" data-id="element-1223">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1224">
                    Sync Settings
                  </h4>
                  <div className="space-y-2" data-id="element-1225">
                    <div className="flex items-center justify-between text-sm" data-id="element-1226">
                      <span className="text-gray-600" data-id="element-1227">Sync Frequency</span>
                      <select className="px-2 py-1 border border-gray-300 rounded-md" data-id="element-1228">
                        <option data-id="element-1229">Daily</option>
                        <option data-id="element-1230">Real-time</option>
                        <option data-id="element-1231">Weekly</option>
                      </select>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-1232">
                      <span className="text-gray-600" data-id="element-1233">Sync Time</span>
                      <input type="time" className="px-2 py-1 border border-gray-300 rounded-md" value="23:00" data-id="element-1234" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Communication Services */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1235">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1236">
          Communication Services
        </h3>
        <div className="space-y-6" data-id="element-1237">
          {/* SMS Gateway */}
          <div data-id="element-1238">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1239">
              SMS Gateway Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1240">
              <div className="flex items-center justify-between mb-4" data-id="element-1241">
                <div className="flex items-center" data-id="element-1242">
                  <MessageSquareIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-1243" />
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1244">
                    SMS Provider Settings
                  </h4>
                </div>
                <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-1245">
                  Connected
                </span>
              </div>
              <div className="space-y-4" data-id="element-1246">
                <div className="grid grid-cols-2 gap-4" data-id="element-1247">
                  <div data-id="element-1248">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1249">
                      Provider
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-1250">
                      <option data-id="element-1251">Ethio Telecom</option>
                      <option data-id="element-1252">Other Provider</option>
                    </select>
                  </div>
                  <div data-id="element-1253">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1254">
                      Sender ID
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="MUNICIPALITY" data-id="element-1255" />
                  </div>
                </div>
                <div data-id="element-1256">
                  <label className="block text-xs text-gray-500 mb-1" data-id="element-1257">
                    API Credentials
                  </label>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1258">
                    <input type="text" className="px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Username" data-id="element-1259" />
                    <input type="password" className="px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Password" data-id="element-1260" />
                  </div>
                </div>
                <div className="flex justify-end space-x-2" data-id="element-1261">
                  <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1262">
                    Send Test SMS
                  </button>
                  <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-1263">
                    Save Settings
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* SMTP Configuration */}
          <div data-id="element-1264">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1265">
              SMTP Server Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1266">
              <div className="flex items-center justify-between mb-4" data-id="element-1267">
                <div className="flex items-center" data-id="element-1268">
                  <MailIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-1269" />
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1270">
                    Email Server Settings
                  </h4>
                </div>
                <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-1271">
                  Active
                </span>
              </div>
              <div className="space-y-4" data-id="element-1272">
                <div className="grid grid-cols-2 gap-4" data-id="element-1273">
                  <div data-id="element-1274">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1275">
                      SMTP Host
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="smtp.example.com" data-id="element-1276" />
                  </div>
                  <div data-id="element-1277">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1278">
                      Port
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="587" data-id="element-1279" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1280">
                  <div data-id="element-1281">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1282">
                      Username
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="smtp_user" data-id="element-1283" />
                  </div>
                  <div data-id="element-1284">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1285">
                      Password
                    </label>
                    <input type="password" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="••••••••" data-id="element-1286" />
                  </div>
                </div>
                <div className="flex items-center space-x-4" data-id="element-1287">
                  <label className="flex items-center" data-id="element-1288">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" data-id="element-1289" />
                    <span className="ml-2 text-sm text-gray-600" data-id="element-1290">Use SSL</span>
                  </label>
                  <label className="flex items-center" data-id="element-1291">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" data-id="element-1292" />
                    <span className="ml-2 text-sm text-gray-600" data-id="element-1293">Use TLS</span>
                  </label>
                </div>
                <div className="flex justify-end space-x-2" data-id="element-1294">
                  <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1295">
                    Send Test Email
                  </button>
                  <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-1296">
                    Save Settings
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* External Registry Connections */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1297">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1298">
          External Registry Connections
        </h3>
        <div className="space-y-6" data-id="element-1299">
          {[{
          name: 'National ID System',
          icon: BuildingIcon,
          status: 'Connected',
          lastSync: '5 minutes ago'
        }, {
          name: 'Business Registry',
          icon: BuildingIcon,
          status: 'Connected',
          lastSync: '15 minutes ago'
        }, {
          name: 'Land Registry',
          icon: MapIcon,
          status: 'Connected',
          lastSync: '1 hour ago'
        }].map(registry => <div key={registry.name} className="border border-gray-200 rounded-lg p-4" data-id="element-1300">
              <div className="flex items-center justify-between mb-4" data-id="element-1301">
                <div className="flex items-center" data-id="element-1302">
                  <registry.icon className="h-5 w-5 text-gray-400 mr-2" data-id="element-1303" />
                  <div data-id="element-1304">
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1305">
                      {registry.name}
                    </h4>
                    <p className="text-xs text-gray-500" data-id="element-1306">
                      Last sync: {registry.lastSync}
                    </p>
                  </div>
                </div>
                <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-1307">
                  {registry.status}
                </span>
              </div>
              <div className="space-y-3" data-id="element-1308">
                <div data-id="element-1309">
                  <label className="block text-xs text-gray-500 mb-1" data-id="element-1310">
                    API Endpoint
                  </label>
                  <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="https://api.registry.gov.et" data-id="element-1311" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1312">
                  <div data-id="element-1313">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1314">
                      Client ID
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="client_id" data-id="element-1315" />
                  </div>
                  <div data-id="element-1316">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1317">
                      Client Secret
                    </label>
                    <input type="password" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="••••••••" data-id="element-1318" />
                  </div>
                </div>
                <div className="flex justify-end space-x-2" data-id="element-1319">
                  <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1320">
                    Test Connection
                  </button>
                  <button className="px-3 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-1321">
                    Update Settings
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* API Management */}
      <div className="pt-8" data-id="element-1322">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1323">
          API Management & Security
        </h3>
        <div className="space-y-6" data-id="element-1324">
          {/* API Keys */}
          <div data-id="element-1325">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1326">
              API Access Keys
            </label>
            <div className="space-y-4" data-id="element-1327">
              {[{
              name: 'Mobile App Integration',
              type: 'Production',
              created: '2024-01-15',
              lastUsed: '5 minutes ago'
            }, {
              name: 'Partner Integration',
              type: 'Production',
              created: '2024-02-01',
              lastUsed: '1 hour ago'
            }, {
              name: 'Development Environment',
              type: 'Development',
              created: '2024-02-10',
              lastUsed: '2 days ago'
            }].map(key => <div key={key.name} className="border border-gray-200 rounded-lg p-4" data-id="element-1328">
                  <div className="flex items-center justify-between mb-3" data-id="element-1329">
                    <div data-id="element-1330">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-1331">
                        {key.name}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-1332">
                        Created: {key.created}
                      </p>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${key.type === 'Production' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-1333">
                      {key.type}
                    </span>
                  </div>
                  <div className="space-y-3" data-id="element-1334">
                    <div data-id="element-1335">
                      <label className="block text-xs text-gray-500 mb-1" data-id="element-1336">
                        API Key
                      </label>
                      <div className="flex space-x-2" data-id="element-1337">
                        <input type={showApiKey ? 'text' : 'password'} className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm" value="sk_test_123456789" readOnly data-id="element-1338" />
                        <button onClick={() => setShowApiKey(!showApiKey)} className="px-3 py-2 border border-gray-300 rounded-md" data-id="element-1339">
                          <EyeIcon className="h-4 w-4 text-gray-500" data-id="element-1340" />
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-1341">
                      <span className="text-gray-500" data-id="element-1342">
                        Last used: {key.lastUsed}
                      </span>
                      <div className="flex space-x-2" data-id="element-1343">
                        <button className="text-blue-600 hover:text-blue-700" data-id="element-1344">
                          Rotate
                        </button>
                        <button className="text-red-600 hover:text-red-700" data-id="element-1345">
                          Revoke
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1346">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-1347" />
                Generate New API Key
              </button>
            </div>
          </div>
          {/* Rate Limiting */}
          <div data-id="element-1348">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1349">
              Rate Limiting Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1350">
              <div className="space-y-4" data-id="element-1351">
                <div className="grid grid-cols-2 gap-4" data-id="element-1352">
                  <div data-id="element-1353">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1354">
                      Request Limit
                    </label>
                    <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="1000" data-id="element-1355" />
                  </div>
                  <div data-id="element-1356">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-1357">
                      Time Window
                    </label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-1358">
                      <option data-id="element-1359">Per Minute</option>
                      <option data-id="element-1360">Per Hour</option>
                      <option data-id="element-1361">Per Day</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-1362">
                  <label className="block text-xs text-gray-500 mb-1" data-id="element-1363">
                    Rate Limit By
                  </label>
                  <div className="space-x-4" data-id="element-1364">
                    <label className="inline-flex items-center" data-id="element-1365">
                      <input type="radio" name="rateLimit" className="h-4 w-4 text-blue-600" data-id="element-1366" />
                      <span className="ml-2 text-sm text-gray-600" data-id="element-1367">
                        IP Address
                      </span>
                    </label>
                    <label className="inline-flex items-center" data-id="element-1368">
                      <input type="radio" name="rateLimit" className="h-4 w-4 text-blue-600" checked data-id="element-1369" />
                      <span className="ml-2 text-sm text-gray-600" data-id="element-1370">
                        API Key
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* API Scopes */}
          <div data-id="element-1371">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1372">
              API Scope Management
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1373">
              <div className="space-y-4" data-id="element-1374">
                {[{
                name: 'read:properties',
                description: 'Read property information'
              }, {
                name: 'write:properties',
                description: 'Modify property records'
              }, {
                name: 'read:payments',
                description: 'View payment information'
              }, {
                name: 'write:payments',
                description: 'Process payments'
              }].map(scope => <div key={scope.name} className="flex items-center justify-between" data-id="element-1375">
                    <div data-id="element-1376">
                      <h4 className="text-sm font-medium text-gray-900" data-id="element-1377">
                        {scope.name}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-1378">
                        {scope.description}
                      </p>
                    </div>
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-1379" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};